import React from 'react';
import windowService from '../../../services/windowService';
import { AgeCategory } from '../models/curriculum';
import {
  AgeGroup,
  AgeGroupButton,
  AgeGroups,
  AgeGroupSectionName,
  BibleStudyAgeGroupsProps,
  InverseInlineBadge,
  SubscribedAgeGroupsSection,
} from './BibleStudyCardsElements';

type PreviewBibleStudiesAgeGroupsProps = BibleStudyAgeGroupsProps & {
  previewConfig: {
    accentColor: string;
  };
};

export function PreviewBibleStudiesAgeGroups({
  brandCode,
  brandName,
  subscribedAgeGroups = [],
  unsubscribedAgeGroups = [],
  recentlyPaired = [],
  previewConfig = { accentColor: '' },
}: PreviewBibleStudiesAgeGroupsProps) {
  const onPreviewClick = (ageName: AgeCategory) => {
    windowService.redirectTo(`#/curriculum/onboarding/${brandCode}?ages=${ageName}`);
  };

  return (
    <>
      <SubscribedAgeGroupsSection
        sectionName="Preview Age Groups"
        brandCode={brandCode}
        entryRoute="people"
        subscribedAgeGroups={subscribedAgeGroups}
        recentlyPaired={recentlyPaired}
      />
      {unsubscribedAgeGroups.length > 0 && (
        <>
          {subscribedAgeGroups.length > 0 && <AgeGroupSectionName>More Age Groups</AgeGroupSectionName>}
          <AgeGroups>
            {unsubscribedAgeGroups.map(([name, accessInfo]) => (
              <AgeGroup key={accessInfo.id}>
                <AgeGroupButton
                  data-qa-hook={`${brandCode}-${name}`}
                  aria-label={`preview ${brandName} ${name} curriculum`}
                  name={name}
                  onClick={() => onPreviewClick(name)}
                  badgeComponent={<InverseInlineBadge color={previewConfig.accentColor}>Preview</InverseInlineBadge>}
                />
              </AgeGroup>
            ))}
          </AgeGroups>
        </>
      )}
    </>
  );
}
